import { 
  VEHICLEBRANDSANDMODELS_FETCHING,
  VEHICLEBRANDSANDMODELS_FAILED,
  VEHICLEBRANDSANDMODELS_SUCCESS,
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case VEHICLEBRANDSANDMODELS_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case VEHICLEBRANDSANDMODELS_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case VEHICLEBRANDSANDMODELS_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }